// External
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  removeInfoFeedMessage,
  setInfoFeedMessage,
  updateSite,
} from "../../store/actions";
import { cloneDeep, get as _get, sortBy, debounce } from "lodash";
import * as olProj from "ol/proj";
import haversineInYards from "../../utils/haversine";
import { hashString } from "../../utils/hashAndUuid";
// Internal
import FloatHeader from "../theme/headers/FloatHeader";
import { defaultMapState } from "./CreateSite";
import InfoTileFeed from "../subscreens/InfoFeed";
import FilterDisplay from "../subscreens/FilterDisplay";
import {
  filterAndSortItems,
  handleFilterDeletion,
  handleSearchChange,
} from "../../utils/FilterDisplayUtils";

import {
  pullCampaignSites,
  pullSiteNoteCategories,
  updateOrCreateSite,
} from "../../store/api/calls";

import BaseMap from "../maps/BaseMap";
import { defaultPointStyle, searchPointStyle } from "../maps/BaseMapStyles";

import Input from "../theme/forms/Input";
import SiteCard from "../cards/SiteCard";
import scrollIntoView from "scroll-into-view-if-needed";
import FeedbackTile from "../theme/modals/FeedbackTile";
import {
  hiddenStyle,
  centroidStyle,
  genericCircleStyle,
  defaultTextStyle,
} from "../maps/olStyles";
import SiteNoteModal from "../theme/modals/SiteNoteModal";
import SiteFilterModal from "../theme/modals/SiteFilterModal";
import BaseModal from "../theme/modals/BaseModal";
import BaseForm from "../theme/forms/BaseForm";
import * as formFields from "../../utils/forms/formFields";
import CreateSiteListItem from "../maps/listItems/CreateSiteListItem";
import api from "../../store/api/api";

class SitesMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...defaultMapState,
      mode: "existing", // can also be 'creating'
      bounds: undefined,
      filterAdHoc: 1,
      focusedMarker: 0,
      loading: false,
      filters: {
        keyword: "",
        noteTags: [],
        sortBy: "name",
        searchFields: [
          "name",
          "city",
          "zip5",
          "statecode",
          "addressline1",
          "addressline2",
          "description",
          "noteString",
        ],
        sortFields: [
          {
            display: "Name",
            value: "name",
          },
          {
            display: "Creation Date",
            value: "created_at",
          },
          {
            display: "City",
            value: "city",
          },
          {
            display: "Number of Notes",
            value: "note_count",
          },
        ],
      },
      selectedSites: [],
      sites: [],
      columns: {
        sites: [],
      },
      siteCanvassData: {},
      pageError: false,
      errMsg: "Whoops! There's been a server error.",
      editModalOpen: false,
      deleteModalOpen: false,
      filterModalOpen: false,
      editingInstance: {},

      //creation state
      siteCreateSearchText: null,
      siteCreateSearchResults: [],
      siteCreateSelectedCandidates: [],
      siteCreateJustCreatedIds: [],
      siteCreateSearchError: false,
      showSearchAreaAgain: false,
      createStep: 1,

      hoveredSite: null,
      visibleSiteIds: this.props.sites.map((s) => s.id),
    };

    this.defaultStyleConfig = {
      count: null,
      radius: 5,
      fill: "#792CC7",
      stroke: "#792CC7",
      name: null,
      showLabel: false,
      fillOpacity: 0.6,
    };

    this.lassoedColor = "#eaa448";
    this.hoverColor = "#c60061";
    this.searchResultColor = "#c60115";
    this.selectedItemColor = "#558C63";

    this.defaultStyle = centroidStyle(this.defaultStyleConfig);

    this.defaultSearchResultStyle = centroidStyle({
      ...this.defaultStyle,
      fill: this.searchResultColor,
      stroke: this.searchResultColor,
      radius: 6,
    });

    this.selectedStyle = centroidStyle({
      ...this.defaultStyleConfig,
      fill: this.selectedItemColor,
      radius: 6,
      fillOpacity: 1,
      stroke: this.selectedItemColor,
    });

    this.focusedSearchResultStyle = centroidStyle({
      ...this.defaultStyle,
      fill: this.searchResultColor,
      stroke: this.searchResultColor,
      radius: 10,
    });

    this.focusedSelectedStyle = centroidStyle({
      ...this.defaultStyleConfig,
      fill: this.selectedItemColor,
      radius: 10,
      fillOpacity: 1,
      stroke: this.selectedItemColor,
    });

    this.hoveredStyle = centroidStyle({
      ...this.defaultStyleConfig,
      fill: this.hoverColor,
      stroke: this.hoverColor,
      radius: 10,
    });

    this.disabledStyle = centroidStyle({
      ...this.defaultStyleConfig,
      fill: "#792CC7",
      stroke: "none",
      radius: 5,
      opacity: 0.4,
    });

    // corresponds to width var set in maps.scss
    this.sideBarColWidth = 280;

    this.editFormInputs = [
      formFields.genericName,
      formFields.genericDescription,
      formFields.addressLine1,
      formFields.addressLine2,
      formFields.city,
      formFields.state,
      { ...formFields.zipcode, dataKey: "zip5" },
    ];
  }

  componentDidMount() {
    if (this.props.focusedCampaign.id) {
      this.handleMountOrCampaignUpdate({});
    } else {
      setTimeout(this.handleMountOrCampaignUpdate.bind(this, {}), 600);
    }
  }

  // TODO: MAKE SURE THAT URL PARAMETER MATCHES THE SELECTED CAMPAIGN, BY SETTING THE CAMPAIGN TO THE SITECANVASS CAMPAIGN PARENT!
  handleMountOrCampaignUpdate = (options = {}) => {
    this.setState({ loading: true });
    pullCampaignSites({ filter_ad_hoc: this.state.filterAdHoc, notes: 1 })
      .then((res) =>
        this.setState({
          sites: sortBy(res.data, (d) => d.name),
        })
      )
      .finally(() => this.setState({ loading: false }));

    pullSiteNoteCategories();
  };

  encodeSites = (sites, source) => {
    return {
      type: "FeatureCollection",
      features: sites.map((site) => {
        return {
          type: "Feature",
          id: site.id,
          geometry: {
            type: "Point",
            coordinates: [
              +site.lon || +site.longitude || 0,
              +site.lat || +site.latitude || 0,
            ],
          },
          properties: {
            label: site.name,
            disabled:
              this.state.mode === "creating" && source === "site-points",
            data: site,
          },
        };
      }),
    };
  };

  // get the sites that were evaluated to be contained in the drawn polygon(s)
  // we only use lasso with siteCreatSearchResults array
  updateSelectedSites({ points }) {
    let sites = [];

    points.forEach((point) => {
      sites.push(this.props.sites.find((site) => site.id === point));
    });

    this.props.removeInfoFeedMessage("count_selected_sites");

    let selectedSites = filterAndSortItems(sites, this.state.filters);

    this.props.setInfoFeedMessage({
      id: "count_selected_sites",
      msg: selectedSites.length + " Total Sites Selected",
    });

    let filteredSites = sites.filter(
      (s) => !selectedSites.find((sel) => sel.id === s.id)
    );

    if (filteredSites.length) {
      // need to also figure out which ones should still just have their default color.
      let hiddenIds = filteredSites.map((s) => s.id);
    }

    this.setState({ selectedSites });
  }

  styleSelectedSites() {
    // re-add any selected sites styles if they exist.
    let selectedSites = filterAndSortItems(
      this.state.selectedSites,
      this.state.filters
    ).map((s) => s.id);
  }

  handlePointsOnFilter() {
    let sites = [...this.props.sites];
    let visibleSites = filterAndSortItems(sites, this.state.filters);
    let visibleIds = [];
    let visibleLabels = [];
    let hiddenIds = [];

    sites.forEach((s) => {
      if (visibleSites.find((v) => v.id === s.id)) {
        visibleIds.push(s.id);
        visibleLabels.push({ id: s.id, name: s.name });
      } else {
        hiddenIds.push(s.id);
      }
    });
  }

  getFiltersDisplay = () => {
    let value =
      this.state.filters.keywordPersist !== ""
        ? { value: this.state.filters.keyword }
        : {};

    const debouncedSiteSearch = debounce((query) => {
      const stateChanges = handleSearchChange(query);
      this.setState(
        {
          ...stateChanges[0],
          filters: {
            ...this.state.filters,
            keyword: stateChanges[1],
          },
        },
        this.handlePointsOnFilter.bind(this)
      );
    }, 300);

    return (
      <div className={"sidebar-filters-wrapper flx flx_column align_center"}>
        <div
          className={"button button-outline mb-2 mt-5"}
          onClick={() => this.changeMode("creating")}
        >
          + Create Sites
        </div>

        <FilterDisplay
          filters={this.state.filters}
          openFilterModal={() => {
            this.setState({ filterModalOpen: true });
          }}
          handleFilterDeletion={(filterType, val, filters) => {
            this.setState(
              {
                filters: handleFilterDeletion(filterType, val, filters),
              },
              this.handlePointsOnFilter
            );
          }}
          handleSearchChange={(val) => {
            debouncedSiteSearch(val);
          }}
          handleSortUpdate={(val) => {
            this.setState({ filters: { ...this.state.filters, sortBy: val } });
          }}
          handleSortDirectionChange={() =>
            this.setState({
              filters: {
                ...this.state.filters,
                sortDsc: !this.state.filters.sortDsc,
              },
            })
          }
          value={value}
        />
      </div>
    );
  };

  onMarkerHover(point) {
    if (!point) {
      this.setState({ focusedMarker: 0 });
      return;
    }

    let id = point.get("id");
    this._setFocusedMarker(id, { center: false, scrollToFixed: true });
  }

  setScrollOnFocus(key, options) {
    let id = `site-card-${key}`;
    if (options.scrollToFixed) {
      id = "fixed-sitecard-div";
    }

    if (key && document.getElementById(id)) {
      scrollIntoView(document.getElementById(id), {
        behavior: "smooth",
        scrollMode: "if-needed",
      });
    }
  }

  _setFocusedMarker(key, options, style) {
    if (!options) options = {};
    const { noState, scroll, exiting, cardFocused } = {
      noState: false,
      scroll: false,
      exiting: false,
      cardFocused: false,
      ...options,
    };

    // if exiting, set the focused id to 0 so focusing stops.
    let focusedId = exiting ? 0 : key;

    if (!noState) {
      this.setState(
        {
          focusedMarker: focusedId,
          cardFocused,
        },
        () => {
          if (scroll) this.setScrollOnFocus.bind(this, key, options);
        }
      );
    }

    //center the map on the focused element
    let matchingElem = [
      ...this.props.sites,
      ...this.state.siteCreateSearchResults,
    ].find((d) => d.id === key);

    if (matchingElem) {
      if (!exiting) {
        let hoverStyle = this.hoveredStyle;
        hoverStyle.setText(defaultTextStyle(matchingElem.name));
      } else {
      }
    }
  }

  _renderSideBarSiteList() {
    // get a copy of state in the order they have been set in.
    let sites = cloneDeep(this.props.sites);

    sites = filterAndSortItems(sites, this.state.filters).filter((site) => {
      return this.state.visibleSiteIds.indexOf(site.id) > -1;
    });

    return (
      <>
        <div className="side-menu-title mb-0">
          <h3 className="primary-text mb-1" style={{ textAlign: "center" }}>
            Sites
          </h3>
        </div>
        <div className="side-menu-body container">
          <div className="sidebar-filter-input side-bar-switch-label">
            {this.getFiltersDisplay()}
          </div>
          {sites.length ? (
            sites.map((item, index) => {
              return (
                <SiteCard
                  key={item.name + "_" + item.id}
                  index={index}
                  id={`site-card-${item.id}`}
                  focused={
                    item.id === this.state.focusedMarker &&
                    !this.state.cardFocused
                  }
                  data={item}
                  onMouseEnter={() => {
                    this.setState({
                      hoveredSite: item,
                      hoveredSource: "site-points",
                    });
                  }}
                  onMouseLeave={() => {
                    this.setState({
                      hoveredSite: null,
                      hoveredSource: "site-points",
                    });
                  }}
                  onDeleteClick={() => this.onOpenDeleteModal(item)}
                  onEditClick={() => this.onOpenEditModal(item)}
                />
              );
            })
          ) : (
            <h6 className={"my-6"} style={{ textAlign: "center" }}>
              No sites in this area.
            </h6>
          )}
        </div>
      </>
    );
  }

  handleFilterModalClose = (filters) => {
    this.setState(
      { filterModalOpen: false, filters },
      this.handlePointsOnFilter
    );
  };

  setPageError(msg, timeout = 3000) {
    this.setState(
      {
        pageError: true,
        errMsg: msg,
      },
      setTimeout(() => this.setState({ pageError: false }), timeout)
    );
  }

  _isError = () => {
    const error =
      this.props.sites_error ||
      this.props.siteroutes_error ||
      this.state.pageError;
    // if (error) debugger;
    return error;
  };

  zoomCallBack = (val) => {
    this.setState({ zoom: val });
  };

  onOpenEditModal = (modelInstance = {}) => {
    this.editFormInputs.forEach((d) => {
      d.value = modelInstance[d.dataKey];
    });

    this.setState({ editModalOpen: true, editingInstance: modelInstance });
  };

  onCloseEditModal = () => {
    //bounds forces a state reset so that the changes show up
    this.setState(
      {
        editModalOpen: false,
        editingInstance: {},
      },
      this.handlePointsOnFilter
    );
  };

  onOpenDeleteModal = (modelInstance) => {
    this.setState({ deleteModalOpen: true, editingInstance: modelInstance });
  };

  onCloseDeleteModal = () => {
    this.setState({ deleteModalOpen: false });
  };

  handleUpdateCreateSubmission = (data) => {
    const id = this.state.editingInstance.id;
    const campaign = this.props.focusedCampaign.id;
    if (id) data = { ...data, id };

    data = { ...data, campaign };
    updateOrCreateSite(data).then(this.onCloseEditModal());
  };

  handleRemoveSubmission = () => {
    const id = this.state.editingInstance.id;
    const data = { is_active: false, id };

    updateOrCreateSite(data)
      .then(() => {
        const filteredSites = this.props.sites.filter((d) => d.id !== id);
        this.setState({ sites: filteredSites });
      })
      .then(this.onCloseDeleteModal());
  };

  ///CREATION MODE FUNCTIONS
  changeMode = (mode) => {
    this.setState({
      mode,
      createStep: 1,
      siteCreateSearchText: null,
      siteCreateSearchResults: [],
      siteCreateSelectedCandidates: [],
      siteCreateJustCreatedIds: [],
      siteCreateSearchError: false,
      showSearchAreaAgain: false,
      filters: {
        ...this.state.filters,
        keywordPersist: this.state.filters.keyword,
      },
    });
  };

  _renderSideBarCreateController = () => {
    return (
      <>
        {this.state.createStep === 1 && this._renderCreateControllerBodyStep1()}
        {this.state.createStep === 2 && this._renderCreateControllerBodyStep2()}
      </>
    );
  };

  _renderCreateControllerBodyStep1 = () => {
    let candidates = cloneDeep(this.state.siteCreateSearchResults);
    let selectedCandidateIds = this.state.siteCreateSelectedCandidates.map(
      (d) => d.id
    );

    return (
      <>
        <div className="side-menu-title mb-0">
          <h3
            className="primary-milligram-text mb-1"
            style={{ textAlign: "center" }}
          >
            Create Sites
          </h3>
        </div>
        <div className="side-menu-body container">
          <div className="sidebar-filter-input side-bar-switch-label">
            <div
              className={"sidebar-filters-wrapper flx flx_column align_center"}
            >
              <div
                className={"button button-clear danger-text mb-2 mt-5"}
                onClick={() => this.changeMode("existing")}
              >
                Cancel
              </div>
              <Input
                value={this.state.siteCreateSearchText}
                onChange={this.handleCreateSiteSearchInput}
                placeholder="Search for an address, store, or place"
                classNames={"full-width"}
              />

              {!!selectedCandidateIds.length && (
                <div
                  className={"button success"}
                  onClick={this._createAllSelectedSites}
                >
                  Create {selectedCandidateIds.length} sites
                </div>
              )}
            </div>
          </div>
          <div id="fixed-sitecard-div" />
          {candidates.length ? (
            candidates.map((item) => {
              const is_selected = selectedCandidateIds.includes(item.id);

              return (
                <CreateSiteListItem
                  key={item.id}
                  data={item.properties.data}
                  onMouseEnter={() => {
                    this.setState({
                      hoveredSite: item,
                      hoveredSource: "search-points",
                    });
                  }}
                  onMouseLeave={() => {
                    this.setState({ hoveredSite: {}, hoveredSource: null });
                  }}
                  onTitleClick={() => {
                    this.addOrRemoveCandidateFromSelectedList(item);
                  }}
                  selected={is_selected}
                  focused={this.state.focusedMarker === item.id}
                />
              );
            })
          ) : (
            <h6 className={""}>
              Start by searching for something. Try &quot;Target&quot; or
              &quot;Grocery Store&quot;
            </h6>
          )}
        </div>
      </>
    );
  };

  _renderCreateControllerBodyStep2 = () => {
    /*
     *  todo here:
     *   - Flag sites that are too close to other sites
     *   - Add a way for people to exit.
     * */

    const sites = this.props.sites.filter((d) =>
      this.state.siteCreateJustCreatedIds.includes(d.id)
    );

    return (
      <>
        <div className="side-menu-title mb-0">
          <h3 className="success-text mb-1" style={{ textAlign: "center" }}>
            Sites Created
          </h3>
        </div>
        <div className="side-menu-body container">
          <div className="sidebar-filter-input side-bar-switch-label">
            <div
              className={"sidebar-filters-wrapper flx flx_column align_center"}
            >
              <div
                className={"button success my-6"}
                onClick={() => this.changeMode("existing")}
              >
                All Done
              </div>
            </div>
          </div>
          {/* THIS IS EVERYTHING ELSE /*/}
          {sites.map((item, index) => {
            return (
              <SiteCard
                key={item.name + "_" + item.id}
                index={index}
                id={`site-card-${item.id}`}
                focused={
                  item.id === this.state.focusedMarker &&
                  !this.state.cardFocused
                }
                data={item}
                onMouseEnter={() => {
                  let style = this.focusedSelectedStyle;
                  style.setText(defaultTextStyle(item.name));

                  this._setFocusedMarker(
                    item.id,
                    {
                      cardFocused: true,
                      exiting: false,
                    },
                    style
                  );
                }}
                onMouseLeave={() => {
                  let style = this.defaultStyle;
                  this.state.zoom > 13 &&
                    style.setText(defaultTextStyle(item.name));

                  this._setFocusedMarker(item.id, {
                    cardFocused: false,
                    exiting: true,
                  });
                }}
                onDeleteClick={() => this.onOpenDeleteModal(item)}
                onEditClick={() => this.onOpenEditModal(item)}
              />
            );
          })}
        </div>
      </>
    );
  };

  addOrRemoveCandidateFromSelectedList = (searchResult) => {
    const selected_id = searchResult.id;

    let { siteCreateSelectedCandidates } = this.state;

    if (siteCreateSelectedCandidates.map((d) => d.id).includes(selected_id)) {
      siteCreateSelectedCandidates = siteCreateSelectedCandidates.filter(
        (d) => d.id !== selected_id
      );
    } else {
      siteCreateSelectedCandidates = [
        ...this.state.siteCreateSelectedCandidates,
        searchResult,
      ];
    }

    this.setState({ siteCreateSelectedCandidates });
  };

  handleCreateSiteSearchInput = (val) => {
    this.setState({ siteCreateSearchText: val });
    clearTimeout(this.searchDebounce);
    this.searchDebounce = setTimeout(
      () => this.searchForSiteCandidates(val),
      600
    );
  };

  // need to get distance from site on map and
  // search result to see if the result already exists
  getDistance(x, y) {
    const existingPoints = this.state.sites.map((d) => [
      parseFloat(d.lon),
      parseFloat(d.lat),
    ]);
    x = parseFloat(x);
    y = parseFloat(y);
    return existingPoints.some((d) => {
      const dist = Math.sqrt(Math.pow(d[0] - x, 2) + Math.pow(d[1] - y, 2));
      return dist <= 0.0001;
    });
  }

  searchForSiteCandidates = (val) => {
    if (!val) val = this.state.siteCreateSearchText;
    if (val.length < 3) return;

    // google documentation for text search and geographic bias:
    // https://developers.google.com/maps/documentation/places/web-service/search-text

    //first I need to get the center of the map;
    let center = [
      +this.state.viewState.latitude,
      +this.state.viewState.longitude,
    ];
    let corner = [
      +this.state.viewState.bounds._ne.lat,
      +this.state.viewState.bounds._ne.lng,
    ];

    //distance between the two is radius
    let radius = Math.round(
      haversineInYards(center[0], center[1], corner[0], corner[1])
    );

    //rounded lat,lon format, url encoded
    const center_string =
      Math.round(center[0] * 1000) / 1000 +
      "%2C" +
      Math.round(center[1] * 1000) / 1000;

    this.setState({
      loading: true,
      siteCreateSearchError: false,
      showSearchAreaAgain: false,
    });
    return api
      .get("/geocode", {
        address: val,
        location: center_string,
        radius: radius,
      })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.results) {
          const results = res.data.results.map((d, i) => {
            const lat = d.geometry.location.lat;
            const lon = d.geometry.location.lng;
            const isAlreadyInList = this.getDistance(lon, lat);

            return {
              isAlreadyInList,
              type: "Feature",
              id: i + 1,
              source: "search-points",
              geometry: {
                type: "Point",
                coordinates: [lon, lat],
              },
              properties: {
                label: d.name,
                data: d,
                disabled: false,
              },
            };
          });
          this.setState({
            siteCreateSearchResults: results.filter((n) => !n.isAlreadyInList),
          });
        }
        this.setBounds();
      })
      .catch(() => this.setState({ siteCreateSearchError: true }));
  };

  // site creation call
  _createSite = (site) => {
    const { place_id } = site.properties.data;

    return api
      .get("/get-google-place", { place_id })
      .then((res) => {
        //you must explicitly remove id (which is the place id), otherwise api file with think this is a patch request
        return {
          ...res.data,
          addressline1: res.data.street_number + " " + res.data.street_name,
          statecode: res.data.state,
          lat: site.geometry.coordinates[1],
          lon: site.geometry.coordinates[0],
          googleplace: res.data.id,
          id: undefined,
        };
      })
      .then((siteData) => updateOrCreateSite({ ...siteData }))
      .then((siteObj) => {
        this.setState({
          siteCreateJustCreatedIds: [
            ...this.state.siteCreateJustCreatedIds,
            siteObj.id,
          ],
        });
        return siteObj;
      });
  };

  _createAllSelectedSites = () => {
    let selectedSites = this.state.siteCreateSelectedCandidates;
    let promises = selectedSites.map((site) => this._createSite(site));

    this.setState({ loading: true });
    Promise.all(promises)
      //clear sites
      .then((newSites) => {
        this.setState({
          createStep: 2,
          siteCreateSearchResults: [],
          siteCreateSearchText: null,
          // sites: [...this.state.sites, ...newSites],
          loading: false,
        });
      })
      .catch(() => {
        this.setPageError(
          "Something went wrong. Unable to create those sites."
        );
      });
  };

  _renderMenu = () => {
    return (
      <div className={`map-side-menu ${this.state.sideBarClosed && "closed"}`}>
        <div className="side-menu-wrapper" id="side-menu-scroll-wrapper">
          {this.state.mode === "creating"
            ? this._renderSideBarCreateController()
            : this._renderSideBarSiteList()}
        </div>

        <div className={`side-menu-select-wrapper`} style={{ width: "1px" }}>
          <div className={"side-menu-option"}>
            <Link to={"/site-list"}>
              <div className={"button primary-milligram"} onClick={() => null}>
                List View
              </div>
            </Link>
          </div>

          {this.state.showSearchAreaAgain && (
            <div className={"side-menu-option"}>
              <div
                className={"button primary"}
                onClick={() =>
                  this.searchForSiteCandidates(this.state.siteCreateSearchText)
                }
              >
                Search This Area
              </div>
            </div>
          )}

          {this.state.loading && (
            <div className={`side-menu-option loading`}>
              <i className="fas fa-asterisk" />
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    return (
      <>
        <FloatHeader link="/sitecanvass" />
        <div style={{ width: "100vw", height: "100vh" }}>
          {!!this.props.sites.length && (
            <BaseMap
              handleViewChange={(viewState) => {
                this.setState({
                  viewState,
                  visibleSiteIds: viewState.visiblePoints,
                });

                //show button to search again if actively searching for sites
                if (
                  this.state.mode === "creating" &&
                  this.state.siteCreateSearchText
                ) {
                  this.setState({ showSearchAreaAgain: true });
                }
              }}
              hoveredFeatures={[this.state.hoveredSite?.id]}
              hoveredSource={this.state.hoveredSource}
              disableDraw={!this.state.siteCreateSearchResults.length} // we only want to disable when sites aren't being created
              sources={[
                {
                  id: "site-points",
                  type: "geojson",
                  data: this.encodeSites(
                    filterAndSortItems(this.props.sites, this.state.filters),
                    "site-points"
                  ),
                  style: defaultPointStyle,
                  isInteractive: true,
                  onHover: (feature) => {},
                  onEndHover: (feature) => {},
                  onDblClick: (feature) => {
                    this.onOpenEditModal(feature.properties.data);
                  },

                  popupComponentGenerator: (feature) => {
                    return (
                      <SiteCard
                        key={feature.id}
                        index={0}
                        id={`site-card-${feature.id}`}
                        data={feature.properties.data}
                        onDeleteClick={() =>
                          this.onOpenDeleteModal(feature.properties.data)
                        }
                        onEditClick={() =>
                          this.onOpenEditModal(feature.properties.data)
                        }
                      />
                    );
                  },
                },
                {
                  id: "search-points",
                  type: "geojson",
                  data: {
                    type: "FeatureCollection",
                    features: this.state.siteCreateSearchResults,
                  },
                  selectedFeatures: this.state.siteCreateSelectedCandidates,
                  style: searchPointStyle,
                  isInteractive: true,
                  onHover: (feature) => {
                    return true;
                  },
                  onEndHover: () => {
                    return true;
                  },
                  onClick: (feature) => {
                    this.addOrRemoveCandidateFromSelectedList(feature);
                  },
                  popupComponentGenerator: (feature) => {
                    let selectedCandidateIds =
                      this.state.siteCreateSelectedCandidates.map((d) => d.id);
                    return (
                      <CreateSiteListItem
                        key={feature.id}
                        data={feature.properties.data}
                        onMouseEnter={() => {
                          this.setState({
                            hoveredSite: feature,
                            hoveredSource: "search-points",
                          });
                        }}
                        onMouseLeave={() => {
                          this.setState({
                            hoveredSite: {},
                            hoveredSource: null,
                          });
                        }}
                        onTitleClick={() => {
                          this.addOrRemoveCandidateFromSelectedList(feature);
                          this.setState({ clickedSite: feature });
                        }}
                        selected={
                          selectedCandidateIds.indexOf(feature.id) !== -1
                        }
                        focused={this.state.focusedMarker === feature.id}
                      />
                    );
                  },
                },
              ]}
            />
          )}
          <InfoTileFeed
            showInfoFeed={true}
            messageStyle={{
              lineHeight: "1.5m",
              color: "#1679c7", // primary text color
              fontWeight: "bold",
              alignItems: "center",
              justifyContent: "center",
              fontSize: ".8em",
              padding: ".5em",
              zIndex: "9999",
            }}
          />

          {this._renderMenu()}
          <SiteNoteModal showCloseIcon center />

          {this.state.filterModalOpen && (
            <SiteFilterModal
              showCloseIcon
              center
              handleOnClose={this.handleFilterModalClose}
              open={true}
              filters={this.state.filters}
            />
          )}
          {this.state.deleteModalOpen && (
            <BaseModal open={true} onClose={this.onCloseDeleteModal} center>
              <div className="modal-internal-wrapper">
                <p>
                  Are you sure you want to remove the site{" "}
                  <b>{this.state.editingInstance.name}</b>?
                </p>
                <div className="button-wrapper">
                  <form
                    className={"m-0 p-0"}
                    onKeyPress={(e) => {
                      if (e.keyCode === 13) {
                        this.handleRemoveSubmission();
                      }
                    }}
                  >
                    <div
                      className="button"
                      onClick={this.handleRemoveSubmission}
                    >
                      Remove
                    </div>
                    <div
                      className="button button-outline"
                      onClick={this.onCloseDeleteModal}
                    >
                      Cancel
                    </div>
                  </form>
                </div>
              </div>
            </BaseModal>
          )}
          <BaseModal
            title={`Edit ${this.state.editingInstance.name}`}
            open={this.state.editModalOpen}
            onClose={this.onCloseEditModal}
            center
          >
            <BaseForm
              inputs={this.editFormInputs}
              onCancel={this.onCloseEditModal}
              onSubmit={this.handleUpdateCreateSubmission}
            />
          </BaseModal>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  focusedCampaign: state.session.focusedCampaign,
  sites: state.sites.data,
  sites_loading: state.sites.loading,
  sites_error: state.sites.error,
  siteRoutes: state.siteRoutes.data,
  siteroutes_loading: state.siteRoutes.loading,
  siteroutes_error: state.siteRoutes.error,
  loading: state.sites.loading || state.siteRoutes.loading,
  sessionVars: state.session.vars,
});

// TODO: is this necessary on this page?
const mapDispatchToProps = (dispatch) => ({
  removeInfoFeedMessage: (msg) => dispatch(removeInfoFeedMessage(msg)),
  setInfoFeedMessage: (msg) => dispatch(setInfoFeedMessage(msg)),
  updateSite: (site) => dispatch(updateSite(site)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SitesMap);

/*
* to create a site:
*
* 1) Get the place id from the original search request
* 2) Ping the get google place endpoint, which sends back the detailed data
*       http://127.0.0.1:8000/get-google-place?place_id=ChIJhYS17SZ5bIcR0Lh8OXFAFeI&campaign=1
*
*   ping the sites endpoint:
*
*
* http://127.0.0.1:8000/sites/?campaign=1
*
*   {
    "lat": 40.013952,
    "lon": -105.281769,
    "googleplace": 36922,
    "name": "Boulder Public Library - Main Library",
    "addressline1": "1001 Arapahoe Ave",
    "city": "Boulder",
    "statecode": "CO",
    "zip5": "80302",
    "day0_open": "12:00",
    "day0_close": "17:00",
    "day1_open": "09:00",
    "day1_close": "19:00",
    "day2_open": "09:00",
    "day2_close": "19:00",
    "day3_open": "09:00",
    "day3_close": "19:00",
    "day4_open": "09:00",
    "day4_close": "19:00",
    "day5_open": "12:00",
    "day5_close": "17:00",
    "day6_open": "12:00",
    "day6_close": "17:00"
}
*
*  Route this through a Promise.allSettled () call. Handle failures with an error message box.
*
*  Filter out any sites that failed the google place call, then call  again on site create, return a list of sites.
*
*  Those sites should be the same as the other ones, but without much to work on.
*
*
*
* */
